import { colors, font, lineHeights } from "./";
import components from "./components";
import config from "./config";
export var breakpoints = ['576px', '992px', '1200px', '1300px'];
var theme = {
    space: [0, 8, 16, 24, 32, 40, 48],
    breakpoints: breakpoints,
    colors: colors,
    fontSizes: ['0.75rem', '1rem', '1.125rem', '1.25rem', '1.5rem'],
    font: font,
    lineHeights: lineHeights,
    components: components,
    config: config,
};
export default theme;
//# sourceMappingURL=theme.js.map